import { Component } from 'react';
import Log from '@deephaven/log';
import ContextActionUtils from "./ContextActionUtils.js";
var log = Log.module('GlobalContextAction');
class GlobalContextAction extends Component {
  constructor(props) {
    super(props);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidMount() {
    document.body.addEventListener('contextmenu', this.handleContextMenu);
    document.body.addEventListener('keydown', this.handleKeyDown);
  }
  componentWillUnmount() {
    document.body.removeEventListener('contextmenu', this.handleContextMenu);
    document.body.removeEventListener('keydown', this.handleKeyDown);
  }
  handleContextMenu(evt) {
    var e = evt;
    if (e.contextActions == null) {
      e.contextActions = [];
    }
    var action = this.props.action;
    if (action.title == null && !action.menuElement) {
      return;
    }
    if (e.contextActions == null) {
      e.contextActions = [];
    }
    e.contextActions.push(action);
    log.debug('Received context menu event at global action! Menu items are now: ', e.contextActions);
  }
  handleKeyDown(e) {
    var action = this.props.action;
    if (!ContextActionUtils.actionsDisabled && action.shortcut !== undefined && action.shortcut.matchesEvent(e)) {
      var _action$action;
      log.debug('Global hotkey matched!', e);
      (_action$action = action.action) === null || _action$action === void 0 || _action$action.call(action, e);
      e.preventDefault();
      e.stopPropagation();
    }
  }
  render() {
    return null;
  }
}
export default GlobalContextAction;
//# sourceMappingURL=GlobalContextAction.js.map